import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollytellingCards {
    constructor() {
        this.container = document.querySelector('.js-scrollytelling-cards');
    }

    init() {
        if (this.container) {
            this.run();
            this.addEventListener();
        }
    }

    run() {
        gsap.registerPlugin(ScrollTrigger);

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.container.querySelector('.cards-container'),
                scrub: true,
                pin: this.container,
                start: "top top",
                end: "+=100%"
            }
        })

        tl
            .to('.card-wrapper', {
                rotate: "20deg",
                transformOrigin: "center 5000px"
            })
    }

    addEventListener() {
        const cards = this.container.querySelectorAll('.card');

        cards.forEach((card, index) => {
            card.addEventListener('click', (e) => {
                const element = document.querySelector('[data-modal-content="'+ (card.dataset.modal) + '"]');
                const button = card.querySelector('.js-modal-button');
                const rect = button.getBoundingClientRect();
                const transformOrigin = `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`;

                console.log('Modal content selector:', '[data-modal-content="'+ (card.dataset.modal) + '"]');
                console.log('Element found:', element);

                if (element) {
                    gsap.from(element, {
                        scale: 0,
                        transformOrigin: transformOrigin,
                        duration: 0.25,
                        ease: 'power2.inOut'
                    });
                } else {
                    console.warn('Modal content element not found for index:', index);
                }

                console.log('Card index:', index);
            });
        });
    }

}

export default new ScrollytellingCards();
